import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch, useStore } from 'react-redux';
import { Row, Col, Typography } from 'antd';
import { Radio, Picker, List, NavBar, Button, Modal, Tabs, Badge, DotLoading, Mask, ActionSheet, Collapse, Popup, Space, Ellipsis } from 'antd-mobile';
import Icofont from 'react-icofont';
import { createUseStyles } from 'react-jss'
import { errorCatch, GET, JSX, JSXMap, POST, pushStateHistoryModal, subscribe, unsubscribe, useTranslateContext, useUserConfigContext, IfElse } from 'fennec-ui'
// import RenderToLayer from '../../../components/RenderToLayer'
import RenderToLayer from '../../common/RenderToLayer'
// import REDUX_Protocol from '../../../objects/Protocol/reducer'
import REDUX_Protocol from '../../objects/Protocol/reducer'
import './index.less';
import { useAuth } from 'fennec-ui';
import { useNavigate } from 'react-router-dom';
// import { useEventContext } from '../../../components/Context';
import { getIndexColor } from '../../common/Tool';
import { useEventContext } from '../../common/Context';
import MaleIcon from '../MaleIcon';
import FemaleIcon from '../FemaleIcon';
// import { getIndexColor } from '../../../components/Tool';
var _ = require('lodash');

const MaskWithLoading = ({ visible, setVisible }) => {
    return (
        <Mask visible={visible} opacity='thin' onMaskClick={(setVisible) ? () => setVisible(false) : undefined}
        // getContainer={()=>document.body}
        >
            <div style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "24px",
                width: "150px",
                height: "150px",
                marginTop: "-75px",
                marginLeft: "-75px",
                // background: "white",
                // borderRadius: "16px",
            }}>
                <DotLoading color='white' />
            </div>
        </Mask >
    )
}

const styleBtn = {
    padding: "0px 5px",
    paddingTop: "4px",
    minWidth: "45px",
    minHeight: "34px",
    // minHeight: "36px",
    fontWeight: "400",
    fontSize: "20px",
    color: "#c1c1c1",
    // textShadow: "1px 1px 2px #848484, 0 0 1em white"
};
const styleBtnActive = {
    padding: "0px 5px",
    paddingTop: "4px",
    minWidth: "45px",
    minHeight: "34px",
    // minHeight: "36px",
    backgroundColor: "#f9f9f9",
    fontWeight: "600",
    fontSize: "20px",
    color: "#000", //"#ff8405",
    textShadow: "1px 1px 2px #848484, 0 0 1em white"
};
const useStyles = createUseStyles({
    pickerItem: {
        '& .am-list-line .am-list-extra': {
            display: "none"
        },
        '& .am-list-line .am-list-content': {
            fontSize: "14px"
        },
        '& .am-list-line .am-list-arrow': {
            height: "11px"
        }
    },
    buttonBadge: {
        '&.adm-badge-dot': {
            minWidth: "6px",
            width: "6px",
            height: "6px",
            borderRadius: "3px",
        }
    },
    btn: styleBtn,
    btnActive: styleBtnActive
})
const dancerIconSmall = (number, color1, color2) => (
    // blue: linear-gradient(rgb(126 186 249), rgb(0 69 155))
    // red: linear-gradient(rgb(249 126 126), rgb(155 0 0))

    <div style={{
        width: "28px",
        height: "28px",
        borderRadius: "8px",
        display: "flex",
        justifyContent: "center",
        background: `linear-gradient(to bottom, ${color1 || "rgba(185, 185, 185)"}, ${color2 || "#000000"})`,
    }}>
        <div style={{ fontSize: "16px", fontWeight: "600", color: "white", alignSelf: "center" }}>
            <span>{number}</span>
        </div>
    </div>
);
const dancerIconSmallColor = (number, color) => (
    <div style={{
        width: "28px",
        height: "28px",
        borderRadius: "8px",
        display: "flex",
        justifyContent: "center",
        backgroundColor: color,
    }}>
        <div style={{ fontSize: "16px", fontWeight: "600", color: "white", alignSelf: "center" }}>
            <span>{number}</span>
        </div>
    </div>
);
const dancerIcon = (number) => (
    <div style={{
        width: "36px",
        height: "36px",
        borderRadius: "8px",
        display: "flex",
        justifyContent: "center",
        background: "linear-gradient(to bottom, rgba(185, 185, 185), #000000)",
    }}>
        <div style={{ fontSize: "18px", fontWeight: "600", color: "white", alignSelf: "center" }}>
            <span>{number}</span>
        </div>
    </div>
);
const dancerIconColor = (number, color) => (
    <div style={{
        width: "36px",
        height: "36px",
        borderRadius: "8px",
        display: "flex",
        justifyContent: "center",
        backgroundColor: color,
    }}>
        <div style={{ fontSize: "18px", fontWeight: "600", color: "white", alignSelf: "center" }}>
            <span>{number}</span>
        </div>
    </div>
);

const statPrepair = (protocol) => {
    var s = {};
    var dancers = {};
    var noValues = true;
    var count = 0;
    var maxCountEqualScores = 0;
    var kolOtsenokPoParametru = 0;
    if (!protocol) return {};
    if (protocol.genderID === 2) {
        count = protocol.judgeBunch.bunch.tour.kolichestvoPlyusovPartnershi;
        maxCountEqualScores = protocol.judgeBunch.bunch.tour.maksKolOdinakovikhOtsenokPartnershi;
        kolOtsenokPoParametru = protocol.judgeBunch.bunch.tour.kolOtsenokPoParametruPartnershi;
    } else {
        count = protocol.judgeBunch.bunch.tour.kolichestvoPlyusovPartneri;
        maxCountEqualScores = protocol.judgeBunch.bunch.tour.maksKolOdinakovikhOtsenokPartneri;
        kolOtsenokPoParametru = protocol.judgeBunch.bunch.tour.kolOtsenokPoParametruPartneri;
    }
    protocol?.protocolDancer?.forEach(dancer => {
        dancers[dancer.ID] = { good: true, summ: 0, error: false }
        dancer.protocolDancerParams.forEach(item => {
            if (item.value) {
                noValues = false;
            }
            if (protocol.judgeBunch.bunch.tour.protocolValueTypeID === 1) {
                // if (!s[item.criterionParams.criterionID]) s[item.criterionParams.criterionID] = { value: 0, good: true, check: true, criterion: item.criterionParams.criterion, params: {} };
                // s[item.criterionParams.criterionID].value += (item.value !== null) ? item.value : 0;
                // s[item.criterionParams.criterionID].good = (s[item.criterionParams.criterionID].value !== count) ? false : true;

                if (!s[item.criterionParams.criterionID]) s[item.criterionParams.criterionID] = { good: true, check: true, criterion: item.criterionParams.criterion, params: {} };

                if (!s[item.criterionParams.criterionID].params[item.criterionParamsID]) {
                    s[item.criterionParams.criterionID].params[item.criterionParamsID] = { countValue: 0, good: true, check: true }
                }
                s[item.criterionParams.criterionID].params[item.criterionParamsID].countValue += (item.value > 0) ? 1 : 0;

                if (s[item.criterionParams.criterionID].params[item.criterionParamsID].countValue === count) {
                    s[item.criterionParams.criterionID].params[item.criterionParamsID].good = true
                } else {
                    s[item.criterionParams.criterionID].params[item.criterionParamsID].good = false
                }
            } else if (protocol.judgeBunch.bunch.tour.protocolValueTypeID !== 1) {
                if (!item.value && !kolOtsenokPoParametru) {
                    dancers[dancer.ID].good = false;
                }

                if (!s[item.criterionParams.criterionID]) s[item.criterionParams.criterionID] = { value: 0, good: true, check: true, criterion: item.criterionParams.criterion, params: {} };
                s[item.criterionParams.criterionID].value += (item.value !== null) ? item.value : 0;
                s[item.criterionParams.criterionID].good = (!s[item.criterionParams.criterionID].good || (!item.value && kolOtsenokPoParametru === 0)) ? false : true;

                if (!s[item.criterionParams.criterionID].params[item.criterionParamsID]) {
                    s[item.criterionParams.criterionID].params[item.criterionParamsID] = { count: {}, criterionParamsCount: 0, good: true, check: true };
                }

                if (item.value) {
                    s[item.criterionParams.criterionID].params[item.criterionParamsID].criterionParamsCount++;

                    var countValue = s[item.criterionParams.criterionID].params[item.criterionParamsID].count[item.value];
                    if (!countValue) {
                        s[item.criterionParams.criterionID].params[item.criterionParamsID].count[item.value] = 1;
                    } else {
                        s[item.criterionParams.criterionID].params[item.criterionParamsID].count[item.value]++;
                    }


                    dancers[dancer.ID].summ += Math.round((item.value * (item.criterionParams?.weight || 1) * 100)) / 100;//(item.value * (item.criterionParams?.weight || 1));
                }

                if (s[item.criterionParams.criterionID].params[item.criterionParamsID].count[item.value] > maxCountEqualScores) {
                    s[item.criterionParams.criterionID].params[item.criterionParamsID].good = false;
                    s[item.criterionParams.criterionID].params[item.criterionParamsID].check = false;
                    s[item.criterionParams.criterionID].check = false;
                    s[item.criterionParams.criterionID].good = false; // !!!!!!!!!!!!!!!!
                }
            }
        });
    });

    if (!kolOtsenokPoParametru) {
        kolOtsenokPoParametru = protocol?.protocolDancer?.length
    }

    if (protocol.judgeBunch.bunch.tour.protocolValueTypeID === 1) {
        Object.keys(s).forEach(i => {
            if (s[i].good) {
                for (const key in s[i].params) {
                    if (!s[i].params[key].good) {
                        s[i].good = false;
                        break
                    }
                }
            }
        });
    } else {
        if (kolOtsenokPoParametru > 0) {
            Object.keys(s).forEach(i => {
                for (const key in s[i].params) {
                    if (s[i].params[key] && s[i].params[key].criterionParamsCount !== kolOtsenokPoParametru) {
                        s[i].check = false;
                        s[i].good = false; // !!!!!!!!!!!!!!!!
                        s[i].params[key].check = false;
                        s[i].params[key].good = false;
                    }
                }
            });
        }

        var objectValues = []
        for (const key in dancers) {
            if (Object.hasOwnProperty.call(dancers, key)) {
                const element = dancers[key];
                objectValues.push(element);
            }
        }

        if (protocol.judgeBunch.bunch.tour.zapretOdinakovoiSummi) {
            objectValues = objectValues?.sort((a, b) => a.summ - b.summ)
            for (let i = 1; i < objectValues?.length; i++) {
                if (objectValues[i - 1].summ == objectValues[i].summ) {
                    objectValues[i - 1].good = false
                    objectValues[i].good = false
                    objectValues[i - 1].error = true
                    objectValues[i].error = true
                }
            }
        }
    }

    return { data: s, noValues: noValues, dancers: dancers };
};
const protocolCriterionParamsCount = (protocol, protocolCriterionParams) => {
    var count = 0;
    protocolCriterionParams.forEach(protocolCriterian => {
        if (protocol.genderID === 1) {
            if (protocolCriterian.ProtocolParamsMan && protocolCriterian.ProtocolParamsMan.length) {
                count++;
            }
        } else {
            if (protocolCriterian.ProtocolParamsWoman && protocolCriterian.ProtocolParamsWoman.length) {
                count++;
            }
        }
    });
    return count;
};
const stat = (protocol) => {
    var s = { data: {} };
    if (!protocol || !protocol.Protocol) return {};

    s = statPrepair(protocol.Protocol);
    var criterionCount = protocolCriterionParamsCount(protocol.Protocol, protocol.ProtocolCriterian)
    var good = true;
    var check = true;

    if (s.noValues) {
        good = false;
        check = false;
    }

    if (Object.keys(s.data).length !== criterionCount) {
        good = false;
    } else {
        Object.keys(s.data).forEach(i => {
            if (!s.data[i].good) {
                good = false;
            }
        });
    }

    Object.keys(s.data).forEach(i => {
        if (!s.data[i].check) {
            check = false;
        }
    });

    Object.keys(s?.dancers)?.forEach(i => {
        if (!s.dancers[i].good && s.dancers[i].error) {
            good = false;
        }
    });

    return {
        ...s.data,
        good: good,
        check: check
    }
};
const mergeProtocolParamValue = (protocol, protocolDancerParam, value) => {
    var ptcl = {
        ...protocol,
        protocolDancer: protocol?.protocolDancer?.map(p => {
            return {
                ...p,
                protocolDancerParams: p.protocolDancerParams.map(k => {
                    if (k.ID === protocolDancerParam.ID) {
                        return { ...k, value: value }
                    }
                    return k;
                })
            };
        }
        )
    };
    return ptcl;
};

const setCurrentProtocolParamValue = (dispatch, arrayProtocol, protocol, protocolParam, value) => {
    var pr = { ...protocol };
    if (pr.Protocol && pr.Protocol.protocolDancer) {
        for (let item = 0; item < pr.Protocol.protocolDancer.length; item++) {
            const protocolDancer = pr.Protocol.protocolDancer[item];
            for (let p = 0; p < protocolDancer.protocolDancerParams.length; p++) {
                const protocolDancerParam = protocolDancer.protocolDancerParams[p];
                if (protocolDancerParam.ID === protocolParam.ID) {
                    var ptcl = mergeProtocolParamValue(pr.Protocol, protocolParam, value);
                    setCurrentProtocol(dispatch, arrayProtocol, {
                        ...pr,
                        Protocol: ptcl
                    });
                    return;
                }
            }
        }
    }
};

const setCurrentProtocol = (dispatch, arrayProtocol, protocol) => {
    dispatch(REDUX_Protocol.actions.setObject(protocol));
    if (protocol && arrayProtocol && arrayProtocol.length > 0) {
        dispatch(REDUX_Protocol.actions.setArray(arrayProtocol.map(i => {
            if (i.Protocol.ID === protocol.Protocol.ID) {
                return protocol;
            }
            return i;
        })));
    } else {
        dispatch(REDUX_Protocol.actions.setArray([]));
    }
    dispatch({ type: 'stat', payload: stat(protocol) });
};
const mycurrentprotocol = (testing, id, auth, dispatch, current, showModal) => {
    dispatch({ type: 'loading', payload: true });
    GET(auth, (testing) ? `/api/testisudeiskikhattestatsii/mycurrentprotocol/${testing?.ID}` : `/api/mycurrentprotocol/${id}`,
        ({ data }) => {
            if (data.length) {
                var p = data[0];
                if (current) {
                    var pp = data.find(item => item.Protocol.ID === current.ID);
                    if (pp) {
                        p = pp;
                    }
                }
                if (showModal) {
                    showModal(p, data);
                }
                setCurrentProtocol(dispatch, data, p);
            } else {
                if (showModal) {
                    showModal(p, data);
                }
                setCurrentProtocol(dispatch, [], undefined);
            }
            dispatch({ type: 'loading', payload: false });
        },
        (err, type) => {
            if (err) {
                if (type === "fail") {
                    console.log(err.message);
                    if (err.exception) {
                        console.error(err.exception)
                    }
                }
                if (type === "error") {
                    console.log(err);
                }
            }
            // errorCatch(err)
            dispatch({ type: 'loading', payload: false });
        });
};

function ValueButton({ color, auth, value, protocol, protocolDancerParam, protocolDancer, criterion, multiparam, testing }) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const [modalVible, setModalVisible] = useState({});
    const curProt = useSelector(REDUX_Protocol.selector.object);
    const arrayProtocol = useSelector(REDUX_Protocol.selector.array);
    const [userConfig, setUserConfig] = useUserConfigContext();

    const t = useTranslateContext();

    if (!protocolDancerParam) {
        return <></>
    }
    const currentUiMode = () => {
        return (userConfig && userConfig?.ui) ? userConfig?.ui : "2";
    };
    const mode = currentUiMode();

    // 1 - [btn]
    // 2 - [btn][1][2][3][4]
    // 3 - popup
    // 4 - modal

    const change = (value, protocolDancerParam) => {
        if (!protocol.completed) {
            dispatch({ type: 'loading', payload: true });
            if (!value) value = 0;
            var object = { ID: protocolDancerParam.ID, value: value };

            POST(auth, (testing) ? `/api/testisudeiskikhattestatsii/set-protocol-value` : `/api/judge/set-protocol-value`, object, () => {
                setCurrentProtocolParamValue(dispatch, arrayProtocol, curProt, protocolDancerParam, value);
                dispatch({ type: 'loading', payload: false });
            }, (err) => errorCatch(err, () => dispatch({ type: 'loading', payload: false })));
        } else {
            Modal.alert({
                title: t('Протокол заполнен'),
                content: t('Нельзя менять завершенный протокол'),
                closeOnMaskClick: true,
                confirmText: t('Хорошо, не буду'),
                // cancelText: t('Отмена'),
                onConfirm: async () => { },
            })
        }
    };

    const PlusMinus = (val) => {
        switch (val) {
            case 1:
                return (<Icofont icon="plus" style={{ fontSize: "18px" }} />);
            case -1:
                return (<Icofont icon="minus" style={{ fontSize: "22px", fontWeight: "600" }} />);
            default:
                return (<></>);
        }
    };
    const nextPlusMinusValue = (val) => {
        switch (val) {
            case 0:
                return 1;
            case null:
                return 1;
            case undefined:
                return 1;
            case 1:
                return -1;
            case -1:
                return undefined;
            default:
                return undefined;
        }
    };
    const nextDigitValue = (val) => {
        if (val >= criterion.maxScoreValue) {
            return undefined;
        }
        var step = criterion.step || 1;
        step = Math.round(step * 100) / 100;
        switch (val) {
            case null:
                return step;
            case undefined:
                return step;
            case 0:
                return step;
            case criterion.maxScoreValue:
                return undefined;
            default:
                return Math.round((val + step) * 100) / 100;
        }
    };
    const valuesArray = () => {
        var arr = [];
        var step = criterion.step || 1;
        step = Math.round(step * 100) / 100
        var val = step;
        while (val <= criterion.maxScoreValue) {
            // while (val <= 10) {
            arr.push(val);
            val += step;
            val = Math.round(val * 100) / 100
        }
        return arr
    };
    const closeModal = key => () => {
        setModalVisible({ ...modalVible, [key]: false })
    }
    const showModal = key => (e) => {
        e.preventDefault();
        setModalVisible({ ...modalVible, [key]: true })
    }
    const getModal = key => {
        return (modalVible[key]) ? modalVible[key] : false;
    }

    if (protocol.judgeBunch.bunch.tour.protocolValueTypeID === 1) {
        if (multiparam) {
            return (
                <div className='bg border-grey v1-mult'
                    style={{ overflow: "hidden", height: "36px", lineHeight: "24px", width: "100%", padding: "0px", cursor: "pointer" }}
                    onClick={() => change(nextPlusMinusValue(value), protocolDancerParam, criterion)}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div style={{ flex: 1, padding: "4px", wordWrap: "break-word", overflowWrap: "break-word", whiteSpace: "break-spaces", fontSize: "12px", lineHeight: "12px", textAlign: "left" }}>{t(protocolDancerParam.criterionParams.name)}</div>
                        <div className='bg bg-grey dark-5' style={{ flex: 0, padding: "4px", minWidth: "60px", minHeight: "34px", maxHeight: "34px", fontWeight: "600", fontSize: "20px" }}>
                            {PlusMinus(value)}
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className='bg border-grey v1' style={{ display: "flex", justifyContent: "center", alignItems: "center", overflow: "hidden", height: "36px", width: "100%", padding: "0px", cursor: "pointer" }} onClick={() => change(nextPlusMinusValue(value), protocolDancerParam, criterion)}>
                    <div style={{ padding: "0px", fontWeight: "600", fontSize: "20px", textShadow: "1px 1px 2px #848484, 0 0 1em white" }}>{PlusMinus(value)}</div>
                </div>
            );
        }
    } else {
        if (mode === "1") { // 1 - [btn]
            if (multiparam) {
                var step = criterion.step || 1;
                return (
                    <div className='bg border-grey v2m1-mult' style={{ overflow: "hidden", height: "36px", lineHeight: "24px", width: "100%", padding: "0px", cursor: "pointer" }} onClick={() => change(nextDigitValue(value), protocolDancerParam, criterion)}>
                        <div style={{ display: "flex", justifyContent: "space-between", overflow: "hidden", height: "100%" }}>
                            <div style={{ flex: 1, padding: "4px", wordWrap: "break-word", overflowWrap: "break-word", whiteSpace: "break-spaces", fontSize: "12px", lineHeight: "12px", textAlign: "left" }}>
                                {t(protocolDancerParam.criterionParams.name)}
                                <span style={{ fontStyle: "italic", color: "rgb(0,0,0,0.5)" }}>{" (" + step + "-" + criterion.maxScoreValue + ")"}</span>
                            </div>
                            <div style={{ flex: 0, padding: "4px", minWidth: "60px", minHeight: "34px", maxHeight: "34px", backgroundColor: "#f9f9f9", fontWeight: "600", fontSize: "20px", textShadow: "1px 1px 2px #848484, 0 0 1em white" }}>{(value) ? value : undefined}</div>
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className='bg border-grey v2m1' style={{ display: "flex", justifyContent: "center", alignItems: "center", overflow: "hidden", height: "36px", width: "100%", padding: "0px", cursor: "pointer" }} onClick={() => change(nextDigitValue(value), protocolDancerParam, criterion)}>
                        <div style={{ padding: "4px", fontWeight: "600", fontSize: "20px", textShadow: "1px 1px 2px #848484, 0 0 1em white" }}>{(value) ? value : undefined}</div>
                    </div>
                );
            }
        }
        if (mode === "2") { // 2 - [btn][1][2][3][4]
            if (multiparam) {
                var step = criterion.step || 1;
                return (
                    <div className='bg border-grey v2m2-mult' style={{ overflow: "hidden", height: "36px", lineHeight: "24px", width: "100%", padding: "0px", cursor: "pointer" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", overflow: "hidden", height: "100%" }}>
                            <div onClick={() => change(nextDigitValue(value), protocolDancerParam, criterion)}
                                style={{ flex: 1, padding: "4px", color: "#000", flex: "auto", wordWrap: "break-word", overflowWrap: "break-word", whiteSpace: "break-spaces", fontSize: "12px", lineHeight: "12px", textAlign: "left" }}>
                                {t(protocolDancerParam.criterionParams.name)}
                                {/* <span style={{ fontStyle: "italic", color: "rgb(0,0,0,0.5)" }}>{" (" + step + "-" + criterion.maxScoreValue + ")"}</span> */}
                            </div>
                            <div style={{ flex: 0, minHeight: "34px", maxHeight: "34px", display: "flex", justifyContent: "right" }}>
                                {valuesArray().map((item, idx) =>
                                    <div key={idx} className={(value == item) ? classes.btnActive : classes.btn}
                                        onClick={() => (value == item) ? change(undefined, protocolDancerParam, criterion) : change(item, protocolDancerParam, criterion)}
                                        style={{ borderLeft: "1px solid rgb(234 234 234)" }}>
                                        <span>
                                            {item}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className='bg border-grey v2m2' style={{ overflow: "hidden", height: "36px", width: "100%", padding: "0px", cursor: "pointer" }}
                    //onClick={() => change(nextDigitValue(value), protocolDancerParam, criterion)}
                    >
                        <div style={{ minHeight: "34px", maxHeight: "34px", display: "flex", justifyContent: "space-between" }}>
                            {valuesArray().map((item, idx) =>
                                <div key={idx} className={(value == item) ? classes.btnActive : classes.btn}
                                    onClick={() => (value == item) ? change(undefined, protocolDancerParam, criterion) : change(item, protocolDancerParam, criterion)}
                                    style={{ flex: "auto" }}>
                                    <span>
                                        {item}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                );
            }
        }
        if (mode === "3") { // 3 - popup
            if (multiparam) {
                var step = criterion.step || 1;
                return (
                    <div className='bg border-grey v2m3-mult' style={{ overflow: "hidden", height: "36px", lineHeight: "24px", width: "100%", padding: "0px", cursor: "pointer" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", overflow: "hidden", height: "100%" }}>
                            <div onClick={() => change(nextDigitValue(value), protocolDancerParam, criterion)}
                                style={{ flex: 1, padding: "4px", color: "#000", flex: "auto", wordWrap: "break-word", overflowWrap: "break-word", whiteSpace: "break-spaces", fontSize: "12px", lineHeight: "12px", textAlign: "left" }}>
                                {t(protocolDancerParam.criterionParams.name)}
                                <span style={{ fontStyle: "italic", color: "rgb(0,0,0,0.5)" }}>{" (" + step + "-" + criterion.maxScoreValue + ")"}</span>
                            </div>
                            <div style={{ display: "flex", justifyContent: "right" }}>
                                <div className={classes.btnActive}
                                    onClick={() => {
                                        ActionSheet.show({
                                            actions: [
                                                {
                                                    text: (<span style={{}}>{t("Очистить")}</span>),
                                                    key: "clean",
                                                    onClick: () => change(undefined, protocolDancerParam, criterion),
                                                },
                                                ...valuesArray().map((item, idx) => {
                                                    var stl = (value == item) ? {
                                                        backgroundColor: "#f9f9f9",
                                                        fontWeight: "600",
                                                        fontSize: "20px",
                                                        color: "#000", //"#ff8405",
                                                        textShadow: "1px 1px 2px #848484, 0 0 1em white",
                                                        textAlign: "center"
                                                    } : {
                                                        fontWeight: "400",
                                                        fontSize: "20px",
                                                        color: "#c1c1c1",
                                                        textAlign: "center"
                                                    };
                                                    return ({
                                                        text: (<span style={stl}>{item}</span>),
                                                        key: idx,
                                                        onClick: () => {
                                                            if (value == item) {
                                                                change(undefined, protocolDancerParam, criterion);
                                                            } else {
                                                                change(item, protocolDancerParam, criterion);
                                                            };
                                                        },
                                                    })
                                                })],
                                            safeArea: true,
                                            closeOnAction: true,
                                            onClose: () => { },
                                        })
                                    }}
                                    style={{ borderLeft: "1px solid rgb(234 234 234)" }}>
                                    {(value) ? value : undefined}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className='bg border-grey v2m3' style={{ overflow: "hidden", height: "36px", width: "100%", padding: "0px", cursor: "pointer" }}
                        onClick={() => {
                            ActionSheet.show({
                                actions: [
                                    {
                                        text: (<span style={{}}>{t("Очистить")}</span>),
                                        key: "clean",
                                        onClick: () => change(undefined, protocolDancerParam, criterion),
                                    },
                                    ...valuesArray().map((item, idx) => {
                                        var stl = (value == item) ? {
                                            backgroundColor: "#f9f9f9",
                                            fontWeight: "600",
                                            fontSize: "20px",
                                            color: "#000", //"#ff8405",
                                            textShadow: "1px 1px 2px #848484, 0 0 1em white",
                                            textAlign: "center"
                                        } : {
                                            fontWeight: "400",
                                            fontSize: "20px",
                                            color: "#c1c1c1",
                                            textAlign: "center"
                                        };
                                        return ({
                                            text: (<span style={stl}>{item}</span>),
                                            key: idx,
                                            onClick: () => {
                                                if (value == item) {
                                                    change(undefined, protocolDancerParam, criterion);
                                                } else {
                                                    change(item, protocolDancerParam, criterion);
                                                };
                                            },
                                        })
                                    })],
                                safeArea: true,
                                closeOnAction: true,
                                onClose: () => { },
                            })
                        }}>
                        <div className={classes.btnActive}>
                            {(value) ? value : undefined}
                        </div>
                    </div>
                );
            }
        }
        if (mode === "4") { // 4 - modal 
            if (multiparam) {
                var step = criterion.step || 1;
                return (
                    <>
                        <RenderToLayer>
                            <Modal
                                closeOnAction
                                closeOnMaskClick
                                visible={getModal(protocolDancerParam.criterionParams.ID)}
                                onClose={closeModal(protocolDancerParam.criterionParams.ID)}
                                title={<div>
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <div style={{ paddingRight: "13px", paddingTop: "3px" }}>
                                            {!color && dancerIconSmall(protocolDancer.dancerBunch.dancerTour.dancerEvent.number)}
                                            {color && dancerIconSmallColor(protocolDancer.dancerBunch.dancerTour.dancerEvent.number, color)}
                                        </div>
                                        <div style={{ textAlign: "left", paddingTop: "4px", lineHeight: "31px" }}>
                                            <div>{protocolDancer.user.lastname} {protocolDancer.user.firstname}</div>
                                        </div>
                                    </div>
                                    <div style={{ fontWeight: "400", fontSize: "14px" }}>{t(criterion.criterion.name)}</div>
                                    <div style={{ fontSize: "14px" }}>{t(protocolDancerParam.criterionParams.name)}</div>
                                </div>}

                                content={<div>
                                    <div>

                                        <div style={{ padding: "0 10px" }}>
                                            <Button size={"small"} style={{ width: "100%" }} onClick={() => {
                                                change(undefined, protocolDancerParam, criterion);
                                                closeModal(protocolDancerParam.criterionParams.ID)();
                                            }}>{t("Очистить")}</Button>
                                        </div>
                                    </div>
                                    <div style={{ overflowY: "scroll" }}>
                                        {valuesArray().map((item, idx) => {
                                            var stl = (value == item) ? {
                                                backgroundColor: "#f9f9f9",
                                                fontWeight: "600",
                                                fontSize: "20px",
                                                color: "#000", //"#ff8405",
                                                textShadow: "1px 1px 2px #848484, 0 0 1em white",
                                                textAlign: "center"
                                            } : {
                                                fontWeight: "400",
                                                fontSize: "20px",
                                                color: "#c1c1c1",
                                                textAlign: "center"
                                            };
                                            return (<List.Item key={idx} arrow={false} style={{ ...stl, width: "100%" }} onClick={() => {
                                                if (value !== item) {
                                                    change(item, protocolDancerParam, criterion);
                                                }
                                                closeModal(protocolDancerParam.criterionParams.ID)();
                                            }}>
                                                <div style={{ width: "100%", textAlign: "center", cursor: "pointer" }}>{item}</div>
                                            </List.Item>);
                                        }
                                        )}
                                    </div>
                                </div>}
                            />
                        </RenderToLayer>
                        <div className='bg border-grey v2m4-mult' style={{ overflow: "hidden", height: "36px", lineHeight: "24px", width: "100%", padding: "0px", cursor: "pointer" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", overflow: "hidden", height: "100%" }}>
                                <div onClick={() => change(nextDigitValue(value), protocolDancerParam, criterion)}
                                    style={{ flex: 1, padding: "4px", color: "#000", flex: "auto", wordWrap: "break-word", overflowWrap: "break-word", whiteSpace: "break-spaces", fontSize: "12px", lineHeight: "12px", textAlign: "left" }}>
                                    {t(protocolDancerParam.criterionParams.name)}
                                    <span style={{ fontStyle: "italic", color: "rgb(0,0,0,0.5)" }}>{" (" + step + "-" + criterion.maxScoreValue + ")"}</span>
                                </div>
                                <div style={{ display: "flex", justifyContent: "right" }}>
                                    <div className={classes.btnActive}
                                        onClick={showModal(protocolDancerParam.criterionParams.ID)}
                                        style={{ borderLeft: "1px solid rgb(234 234 234)" }}>
                                        {(value) ? value : undefined}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                );
            } else {
                return (
                    <>
                        <RenderToLayer>
                            <Modal
                                closeOnMaskClick
                                closeOnAction
                                visible={getModal(protocolDancerParam.criterionParams.ID)}
                                onClose={closeModal(protocolDancerParam.criterionParams.ID)}
                                title={<div>
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <div style={{ paddingRight: "13px", paddingTop: "3px" }}>
                                            {!color && dancerIconSmall(protocolDancer.dancerBunch.dancerTour.dancerEvent.number)}
                                            {color && dancerIconSmallColor(protocolDancer.dancerBunch.dancerTour.dancerEvent.number, color)}
                                        </div>
                                        <div style={{ textAlign: "left", paddingTop: "4px", lineHeight: "31px" }}>
                                            <div>{protocolDancer.user.lastname} {protocolDancer.user.firstname}</div>
                                        </div>
                                    </div>
                                    <div style={{ fontWeight: "400", fontSize: "14px" }}>{t(criterion.criterion.name)}</div>
                                    <div style={{ fontSize: "14px" }}>{t(protocolDancerParam.criterionParams.name)}</div>
                                </div>}

                                content={<div>
                                    <div>

                                        <div style={{ padding: "0 10px" }}>
                                            <Button size={"small"} style={{ width: "100%" }} onClick={() => {
                                                change(undefined, protocolDancerParam, criterion);
                                                closeModal(protocolDancerParam.criterionParams.ID)();
                                            }}>{t("Очистить")}</Button>
                                        </div>
                                    </div>
                                    <div style={{ overflowY: "scroll" }}>
                                        {valuesArray().map((item, idx) => {
                                            var stl = (value == item) ? {
                                                backgroundColor: "#f9f9f9",
                                                fontWeight: "600",
                                                fontSize: "20px",
                                                color: "#000", //"#ff8405",
                                                textShadow: "1px 1px 2px #848484, 0 0 1em white",
                                                textAlign: "center"
                                            } : {
                                                fontWeight: "400",
                                                fontSize: "20px",
                                                color: "#c1c1c1",
                                                textAlign: "center"
                                            };
                                            return (<List.Item key={idx} arrow={false} style={{ ...stl, width: "100%" }} onClick={() => {
                                                if (value !== item) {
                                                    change(item, protocolDancerParam, criterion);
                                                }
                                                closeModal(protocolDancerParam.criterionParams.ID)();
                                            }}>
                                                <div style={{ width: "100%", textAlign: "center", cursor: "pointer" }}>{item}</div>
                                            </List.Item>);
                                        }
                                        )}
                                    </div>
                                </div>}
                            />
                        </RenderToLayer>
                        <div className='bg border-grey v2m4' style={{ overflow: "hidden", height: "36px", width: "100%", padding: "0px", cursor: "pointer" }}
                            onClick={showModal(protocolDancerParam.criterionParams.ID)}>
                            <div className={classes.btnActive}>
                                {(value) ? value : undefined}
                            </div>
                        </div>
                    </>

                );
            }
        }
    }

}
function BadgeWrapper(prop) {
    const { children, compare, style } = prop;
    const classes = useStyles()
    if (compare()) {
        return (<Badge content={Badge.dot} className={classes.buttonBadge} style={{ ...style, background: "red" }}>{children}</Badge>);
    }
    return children;
};

//--------------------------------------------------------------------------
export default function Judge(props) {
    const { testing, backArrow, onBack } = props;

    const auth = useAuth();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const _event = useEventContext();
    const event = testing || _event;

    const [online, setOnline] = useState(false);
    const loading = useSelector(state => state.mobile.loading);

    const [userConfig, setUserConfig] = useUserConfigContext();
    const t = useTranslateContext();

    const currentProtocol = useSelector(REDUX_Protocol.selector.object);
    const arrayProtocol = useSelector(REDUX_Protocol.selector.array);

    const statistic = useSelector(state => state.mobile.stat) || stat(currentProtocol);
    const { getState } = useStore();

    var peopleOnTabs = false;
    if (currentProtocol && currentProtocol.Protocol && currentProtocol.Protocol.judgeBunch.bunch.tour.protocolValueTypeID !== 1) {
        peopleOnTabs = true;
    }

    useEffect(() => {
        if (event) {
            // "[<CtxObjectName>.<CtxObjectID>.]<ObjectName>.create"
            // "[<CtxObjectName>.<CtxObjectID>.]<ObjectName>.update"
            // "[<CtxObjectName>.<CtxObjectID>.]<ObjectName>.delete"

            let token1 = subscribe(`service.call-mycurrentprotocol-open`, function (msg, payload) {
                mycurrentprotocol(testing, event.ID, auth, dispatch, (currentProtocol) ? currentProtocol.Protocol : undefined, (protocol, array) => {
                    showInformation(protocol, arrayProtocol, array, payload, "open");
                });
            });
            let token2 = subscribe(`service.call-mycurrentprotocol-close`, function (msg, payload) {
                mycurrentprotocol(testing, event.ID, auth, dispatch, (currentProtocol) ? currentProtocol.Protocol : undefined, (protocol, array) => {
                    showInformation(protocol, arrayProtocol, array, payload, "close");
                });
            });
            let token3 = subscribe(`service.JudgeProtocolDancerParamsValue`, function (msg, payload) {
                setCurrentProtocolParamValue(dispatch, arrayProtocol, currentProtocol, payload, payload.value);
            });

            let token4 = subscribe(`service.tour-delete`, function (msg, payload) {
                if (payload.meropriyatieID === event.ID) {
                    mycurrentprotocol(testing, event.ID, auth, dispatch, (currentProtocol) ? currentProtocol.Protocol : undefined, (protocol, array) => {
                        // showInformation(protocol, arrayProtocol, array, payload, "close");
                    });
                }
            });
            let token5 = subscribe(`service.bunch-tour-delete`, function (msg, payload) {
                if (payload.meropriyatieID === event.ID) {
                    mycurrentprotocol(testing, event.ID, auth, dispatch, (currentProtocol) ? currentProtocol.Protocol : undefined, (protocol, array) => {
                        // showInformation(protocol, arrayProtocol, array, payload, "close");
                    });
                }
            });
            let token6 = subscribe(`service.tour-update`, function (msg, payload) {
                if (currentProtocol && arrayProtocol && arrayProtocol.length) {
                    mycurrentprotocol(testing, event.ID, auth, dispatch, (currentProtocol) ? currentProtocol.Protocol : undefined, (protocol, array) => { });
                }
            });
            return () => {
                unsubscribe(token1);
                unsubscribe(token2);
                unsubscribe(token3);
                unsubscribe(token4);
                unsubscribe(token5);
                unsubscribe(token6);
            };
        }
    }, [arrayProtocol, currentProtocol, event, testing]);

    const showInformation = (protocol, oldarray, newarray, payload, event) => {
        if (event === "open") {
            Modal.show({
                title: t("Информация"),
                content: (<div style={{ padding: "5px" }}>
                    <Row gutter={[5, 5]}>
                        <Col span={24} style={{ fontSize: "14px", textAlign: "center" }}>
                            <Typography style={{ fontWeight: "600" }}>{t("Заход")} №{payload[0].number} {t("начат")}.</Typography>
                            <Typography>{t("Протокол доступен для выставления оценок")}</Typography>
                        </Col>
                    </Row>
                </div>),
                closeOnAction: true,
                closeOnMaskClick: true,
            })
        } else if (event === "close") {
            Modal.show({
                title: t("Информация"),
                content: (<div style={{ padding: "5px" }}>
                    <Row gutter={[5, 5]}>
                        <Col span={24} style={{ fontSize: "14px", textAlign: "center" }}>
                            <Typography>{t(payload[0].tour.kategoriiUchastnikovNaMeropriyatiyakh.meropriyatie.nazvanieMeropriyatiya) + " (" + t(payload[0].tour.kategoriiUchastnikovNaMeropriyatiyakh.kategoriyaUchastnikov.nazvanie) + ", " + t(payload[0].tour.kategoriiUchastnikovNaMeropriyatiyakh.tantsevalnayaDistsiplina.nazvanie) + `), ${t("Тур")} №` + payload[0].tour.number + " (" + t(payload[0].tour.tourType.name) + ") "}</Typography>
                            <Typography style={{ fontWeight: "600" }}>{t("Заход")} №{payload[0].number} {t("завершен")}.</Typography>
                            <Typography>{t("Протокол принят") + "."}</Typography>
                        </Col>
                    </Row>
                </div>),
                closeOnAction: true,
                closeOnMaskClick: true,
            })
        }
    };
    //---------------------------------------------------------------------------------------------------------------------------
    useEffect(() => {
        mycurrentprotocol(testing, event.ID, auth, dispatch, (currentProtocol) ? currentProtocol.Protocol : undefined);
    }, [auth, dispatch, testing]);
    const findParam = (protocolDancer, p) => {
        var res = undefined;
        protocolDancer.protocolDancerParams.forEach(param => {
            if (param.criterionParamsID === p.ID) {
                res = param;
                return;
            }
        });
        return res;
    };
    const badgedProtocolPeople = (current, protocol, people, style) => {
        var st = statPrepair(protocol);
        if (
            (st.noValues || !st.data[current.Criterion.ID] || !st.data[current.Criterion.ID].good)) {
            return (<Badge className="badge-dot-small" content={Badge.dot} style={{ background: "red", ...style }}>{t(current.Criterion.name)}</Badge>);
        }
        if (
            (st.noValues || !st.data[current.Criterion.ID] || !st.data[current.Criterion.ID].check)) {
            return (<Badge className="badge-dot-small" content={Badge.dot} style={{ background: "orange", ...style }}>{t(current.Criterion.name)}</Badge>);
        }
        return t(current.Criterion.name);
    };
    const badged = (current) => {
        if (
            (!statistic[current.Criterion.ID] || !statistic[current.Criterion.ID].good)) {
            return (<Badge className="badge-dot-small" content={Badge.dot} style={{ background: "red" }}>{t(current.Criterion.name)}</Badge>);
        }
        if (
            (!statistic[current.Criterion.ID] || !statistic[current.Criterion.ID].check)) {
            return (<Badge className="badge-dot-small" content={Badge.dot} style={{ background: "orange" }}>{t(current.Criterion.name)}</Badge>);
        }
        return t(current.Criterion.name);
    };
    const badgedParameter = (parameter, criterian) => {

        var { data } = statPrepair(currentProtocol.Protocol);
        var sum = data[parameter.CriterionParams.criterionID]?.params[parameter.CriterionParams.ID]?.countValue;

        let u = (
            <div style={{ display: "flex", justifyContent: "start", flexDirection: "column" }}>
                <div style={{ display: "flex", justifyContent: "start", minHeight: "30px" }}>
                    <div style={{
                        fontSize: "12px",
                        maxWidth: "150px",
                        width: "max-content",
                        lineHeight: "15px",
                        overflowWrap: "break-word",
                        whiteSpace: "normal"
                    }}>
                        {t(parameter.CriterionParams.name)}
                    </div>
                </div>
                {(sum) && <div style={{ minHeight: "15px" }}>
                    {currentProtocol.Protocol.judgeBunch.bunch.tour.protocolValueTypeID === 1 &&
                        <div style={{ textAlign: "left", backgroundColor: "transparent", fontSize: "12px", color: "rgb(0,0,0,0.65)" }}>
                            <div>
                                <div style={{ color: "green", display: "flex", justifyContent: "center" }}>
                                    <div style={{}}>
                                        <span style={{ marginLeft: "-1px" }}>+</span>
                                        <span style={{ paddingLeft: "1px" }}>:</span>
                                    </div>
                                    <div style={{ marginLeft: "5px" }}>{sum}</div>
                                </div>
                            </div>
                        </div>
                    }
                </div>}
            </div>
        )
        if ((!statistic[criterian.Criterion.ID] || !statistic[criterian.Criterion.ID].params ||
            !statistic[criterian.Criterion.ID].params[parameter.CriterionParams.ID] ||
            !statistic[criterian.Criterion.ID].params[parameter.CriterionParams.ID].good)) {
            return (
                <Badge className="badge-dot-small" content={Badge.dot} style={{ background: "red" }}>
                    {u}
                </Badge>
            );
        }
        if ((!statistic[criterian.Criterion.ID] || !statistic[criterian.Criterion.ID].params ||
            !statistic[criterian.Criterion.ID].params[parameter.CriterionParams.ID] ||
            !statistic[criterian.Criterion.ID].params[parameter.CriterionParams.ID].check)) {
            return (
                <Badge className="badge-dot-small" content={Badge.dot} style={{ background: "orange" }}>
                    {u}
                </Badge>
            );
        }
        return (u)
    };
    const parametersLineByCriterion = (protocolCriterian, protocol) => {
        var arr = [];
        if (protocol.genderID === 1) {
            if (protocolCriterian.ProtocolParamsMan) {
                protocolCriterian.ProtocolParamsMan.forEach(param => {
                    arr.push({ ...param, title: t(param.CriterionParams.name) });
                });
            }
        } else {
            if (protocolCriterian.ProtocolParamsWoman) {
                protocolCriterian.ProtocolParamsWoman.forEach(param => {
                    arr.push({ ...param, title: t(param.CriterionParams.name) });
                });
            }
        }
        return (arr);
    };
    const criterionLine = () => {
        var arr = [];
        if (currentProtocol) {
            currentProtocol.ProtocolCriterian.forEach(current => {
                var cp = parametersLineByCriterion(current, (currentProtocol) ? currentProtocol.Protocol : undefined);
                if (cp.length) {
                    arr.push({
                        ...current,
                        title: badged(current)
                    });
                }
            });
        }
        return (arr);
    };
    const parametersLine = () => {
        var arr = [];
        if (currentProtocol) {
            currentProtocol.ProtocolCriterian.forEach(current => {
                var cp = parametersLineByCriterion(current, (currentProtocol) ? currentProtocol.Protocol : undefined);
                if (cp.length) {
                    for (let i = 0; i < cp.length; i++) {
                        const c = cp[i];
                        arr.push({
                            ...c,
                            title: badgedParameter(c, current)
                        });
                    }
                }
            });
        }
        return (arr);
    };
    const renderPeopleLine = (el, color) => (
        <div style={{ display: "flex", justifyContent: "start", flexDirection: "column" }}>
            <div style={{ display: "flex", justifyContent: "start" }}>
                <div style={{ paddingRight: "8px", paddingTop: "5px" }}>
                    <BadgeWrapper compare={() => {
                        var s = statPrepair(currentProtocol.Protocol);
                        return !s?.dancers[el.ID]?.good
                    }}>
                        {!color && dancerIconSmall(el.dancerBunch.dancerTour.dancerEvent.number, "#8a8a8a", "#717171")}
                        {color && dancerIconSmallColor(el.dancerBunch.dancerTour.dancerEvent.number, color)}
                    </BadgeWrapper>
                </div>
                <div style={{ textAlign: "left", paddingTop: "2px", lineHeight: "17px" }}>
                    <div>{el.user.lastname}</div>
                    <div>{el.user.firstname}</div>
                </div>
            </div>
            <div style={{ minHeight: "15px", paddingLeft: "36px" }}>
                {currentProtocol.Protocol.judgeBunch.bunch.tour.protocolValueTypeID === 1 &&
                    <div style={{ textAlign: "left", backgroundColor: "transparent", fontSize: "12px", color: "rgb(0,0,0,0.65)" }}>
                        <div>
                            <div style={{ color: "green", display: "flex", justifyContent: "space-between" }}>
                                <div style={{}}>
                                    <span style={{ marginLeft: "-1px" }}>+</span>
                                    <span style={{ paddingLeft: "1px" }}>:</span>
                                </div>
                                <div>{sumPlus(el.protocolDancerParams.map(item => item.value))}</div>
                            </div>
                            <div style={{ color: "red", display: "flex", justifyContent: "space-between" }}>
                                <div style={{}}>
                                    <span>-</span>
                                    <span style={{ paddingLeft: "3px" }}>:</span>
                                </div>
                                <div>{sumMinus(el.protocolDancerParams.map(item => item.value))}</div>
                            </div>
                        </div>
                    </div>
                }
                {currentProtocol.Protocol.judgeBunch.bunch.tour.protocolValueTypeID !== 1 &&
                    <div style={{ textAlign: "left", backgroundColor: "transparent", fontSize: "12px", color: "rgb(0,0,0,0.65)" }}>
                        <div>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div>{el.protocolDancerParams.map(item => (item.value) ? Math.round((item.value * (item.criterionParams?.weight || 1) * 100)) / 100 : 0).reduce(reducer)}</div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
    const peopleLine = () => {
        var arr = [];
        const tour = currentProtocol?.Protocol?.judgeBunch?.bunch?.tour;
        const dancersInBlock = (currentProtocol?.Protocol?.genderID === 1) ? tour?.tantsorovVBlokePartneri : tour?.tantsorovVBlokePartnershi;

        if (dancersInBlock > 0) {
            const chunk = _.chunk(currentProtocol.Protocol.protocolDancer, dancersInBlock);
            chunk.forEach((c, idx) => {
                const color = getIndexColor(idx);
                c.forEach(el => {
                    arr.push({
                        ...el,
                        color: color,
                        _protocol: currentProtocol.Protocol,
                        title: renderPeopleLine(el, color)
                    });
                })
            })

        } else {
            currentProtocol.Protocol?.protocolDancer?.forEach(el => {
                arr.push({
                    ...el,
                    _protocol: currentProtocol.Protocol,
                    title: renderPeopleLine(el, undefined)
                });
            })
        }

        return (arr);
    };

    const sumPlus = (arr) => {
        var acc = 0;
        arr.forEach(item => (item > 0) ? acc += 1 : acc);
        return acc;
    }
    const sumMinus = (arr) => {
        var acc = 0;
        arr.forEach(item => (item < 0) ? acc += 1 : acc);
        return acc;
    }
    const reducer = (accumulator, currentValue) => accumulator + currentValue;

    const renderContentByParameter = (protocolParameter, protocolDancer, color) => (
        <div key={protocolDancer.ID}>
            <div style={{ minHeight: "40px", border: "none", display: "flex", justifyContent: "space-between" }}>
                <div style={{ paddingRight: "10px" }}>
                    <BadgeWrapper compare={() => {
                        var s = statPrepair(currentProtocol.Protocol);
                        return !s?.dancers[protocolDancer.ID]?.good
                    }}>
                        {!color && dancerIcon(protocolDancer?.dancerBunch?.dancerTour?.dancerEvent?.number)}
                        {color && dancerIconColor(protocolDancer?.dancerBunch?.dancerTour?.dancerEvent?.number, color)}
                    </BadgeWrapper>
                </div>
                {currentProtocol.Protocol.judgeBunch.bunch.tour.protocolValueTypeID === 1 &&
                    <div style={{ textAlign: "left", paddingRight: "10px", minWidth: "35px", minHeight: "40px", backgroundColor: "transparent", fontSize: "12px", color: "rgb(0,0,0,0.65)" }}>
                        <div>
                            <div style={{ color: "green", display: "flex", justifyContent: "space-between" }}>
                                <div style={{}}>
                                    <span style={{ marginLeft: "-1px" }}>+</span>
                                    <span style={{ paddingLeft: "1px" }}>:</span>
                                </div>
                                <div>{sumPlus(protocolDancer.protocolDancerParams.map(item => item.value))}</div>
                            </div>
                            <div style={{ color: "red", display: "flex", justifyContent: "space-between" }}>
                                <div style={{}}>
                                    <span>-</span>
                                    <span style={{ paddingLeft: "3px" }}>:</span>
                                </div>
                                <div>{sumMinus(protocolDancer.protocolDancerParams.map(item => item.value))}</div>
                            </div>
                        </div>
                    </div>
                }
                {currentProtocol.Protocol.judgeBunch.bunch.tour.protocolValueTypeID !== 1 &&
                    <div style={{ textAlign: "left", paddingRight: "10px", minWidth: "25px", minHeight: "40px", backgroundColor: "transparent", fontSize: "12px", color: "rgb(0,0,0,0.65)" }}>
                        <div>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div>{protocolDancer.protocolDancerParams.map(item => (item.value) ? Math.round((item.value * (item.criterionParams?.weight || 1) * 100)) / 100 : 0).reduce(reducer)}</div>
                            </div>
                        </div>
                    </div>
                }
                <div style={{ flex: "auto" }}>
                    {JSX(() => {
                        var pp = findParam(protocolDancer, protocolParameter.CriterionParams);
                        return (<div key={protocolParameter.CriterionParams.ID} style={{ paddingBottom: "1px" }}>
                            <ValueButton
                                color={color}
                                auth={auth}
                                value={((pp) ? pp.value : undefined)}
                                protocolDancer={protocolDancer}
                                protocol={currentProtocol.Protocol}
                                protocolDancerParam={pp}
                                criterion={protocolParameter.CriterionParams}
                                multiparam={undefined}
                                testing={testing}
                            ></ValueButton>
                        </div>);
                    })}
                </div>
            </div>
        </div>
    )
    const contentByParameter = protocolParameter => {
        const tour = currentProtocol?.Protocol?.judgeBunch?.bunch?.tour;
        const dancersInBlock = (currentProtocol?.Protocol?.genderID === 1) ? tour?.tantsorovVBlokePartneri : tour?.tantsorovVBlokePartnershi;
        return (
            <>
                {currentProtocol && <div>

                    {IfElse(dancersInBlock > 0, <div>
                        {JSXMap(_.chunk(currentProtocol.Protocol?.protocolDancer, dancersInBlock), (chunk, idx) => {
                            return (<div key={"m" + idx} className='bg' style={{
                                textAlign: "left", padding: "3px 6px",

                                borderLeftWidth: "1px",
                                borderLeftStyle: "solid",
                                borderLeftColor: getIndexColor(idx),
                            }}>
                                <div style={{ fontSize: "10px" }}>#{idx + 1}</div>
                                {JSXMap(chunk, (protocolDancer, didx) => {
                                    return renderContentByParameter(protocolParameter, protocolDancer, getIndexColor(idx))
                                })}
                            </div>)
                        })}
                    </div>, <div>
                        {JSXMap(currentProtocol.Protocol?.protocolDancer, (protocolDancer, idx) => {
                            return renderContentByParameter(protocolParameter, protocolDancer)
                        })}
                    </div>)}
                </div>}
            </>
        );
    };
    const contentByPeouple = people => {
        var mult = false;
        const _p = people._protocol;
        currentProtocol.ProtocolCriterian.forEach(criterian => {
            if (parametersLineByCriterion(criterian, _p).length > 1) {
                mult = true;
            }
        });
        const dancerStyle = (mult) ? {
            padding: "5px 0",
            borderBottom: "1px solid transparent",
            borderImage: "radial-gradient(rgb(0,0,0,0.65), transparent) 1",
        } : {};
        return (
            <>
                {_p &&
                    <div key={_p.ID + "p"}>
                        <div key={_p.ID}>
                            {criterionLine().map((criterion, idx) => (
                                <div key={idx} style={dancerStyle}>
                                    {mult == true && <div style={{ textAlign: "left", fontWeight: "600" }}>
                                        {badgedProtocolPeople(criterion, _p, people, { marginLeft: "5px" })}
                                    </div>}
                                    <div style={{ minHeight: "40px", borderLeft: (mult == true) ? "1px solid " + ((people.color) ? people.color : "#1890ff") : "", display: "flex", justifyContent: "space-between" }}>
                                        {mult == true && <div style={{ paddingRight: "3px" }}></div>}
                                        <div style={{ flex: "auto" }}>
                                            {parametersLineByCriterion(criterion, _p).map(param => {
                                                var pp = findParam(people, param.CriterionParams);
                                                return (<div key={param.CriterionParams.ID} className="parameter-badge" style={{
                                                    paddingBottom: "1px",
                                                }}>
                                                    <BadgeWrapper compare={() => statistic[pp.criterionParams.criterionID] && statistic[pp.criterionParams.criterionID].params[pp.criterionParamsID] && statistic[pp.criterionParams.criterionID].params[pp.criterionParamsID].good === false}>
                                                        <ValueButton style={{ width: "100%" }} auth={auth} value={((pp) ? pp.value : undefined)} testing={testing} protocolDancer={people} protocol={_p} protocolDancerParam={pp} criterion={param.CriterionParams} multiparam={true} completed={currentProtocol.Protocol.completed}></ValueButton>
                                                    </BadgeWrapper>
                                                </div>);
                                            })}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                }
            </>
        );
    };
    const completed = () => {
        Modal.confirm({
            title: t('Готово?'),
            content: <div style={{ padding: "12px" }}>{t('Вы уверены что хотите завершить заполнение протокола?')}</div>,
            confirmText: t('Да'),
            cancelText: t('Отмена'),
            onConfirm: async () => {
                var object = { ...currentProtocol.Protocol, completed: true };
                POST(auth, (testing) ? `/api/testisudeiskikhattestatsii/protocol-compleate` : `/api/judge/protocol-compleate`, object, () => {
                    mycurrentprotocol(testing, event.ID, auth, dispatch, (currentProtocol) ? currentProtocol.Protocol : undefined);
                }, errorCatch);
            },
        })
    };
    const classes = useStyles()

    const badge = (statistic) => {
        if (!statistic.good) {
            return <Icofont key={"1.2"} icon="close-circled" size={"xxs"} style={{ color: "red" }} />
        } else {
            if (!statistic.check) {
                return <Icofont key={"1.3"} icon="close-circled" size={"xxs"} style={{ color: "orange" }} />
            } else {
                return <Icofont key={"1.1"} icon="check-circled" size={"xxs"} style={{ color: "green" }} />
            }
        }
    }

    const stack = [];
    const getStack = React.useCallback(() => {
        return stack;
    }, []);

    const [open, setOpen] = useState(false);
    const menuClose = () => {
        if (open) {
            window.history.back();
        }
    }
    const onOpenChange = () => {
        if (!open) {
            pushStateHistoryModal(setOpen, getStack);
            setOpen(true);
            return
        }
        menuClose();
    }

    const containerRef = React.useRef(null);


    return (
        <div ref={containerRef} className='judge-component' style={{ height: "100%" }}>
            <div style={{ backgroundColor: 'white', textAlign: 'center' }}>
                {(currentProtocol && arrayProtocol && arrayProtocol.length > 0) &&
                    <div>
                        <div>
                            <Popup
                                position="bottom"
                                visible={open}
                                onMaskClick={menuClose}
                                bodyStyle={{ height: '35vh' }}
                                // getContainer={() => document.getElementById("judge-component")}
                                getContainer={() => (containerRef.current) ? containerRef.current : document.body}
                            >
                                <div style={{ padding: "15px" }}>
                                    <div style={{ paddingBottom: "10px" }}>
                                        <div style={{ paddingBottom: "5px", fontWeight: "300", color: "#747474" }}>{t('Отображение протокола')}</div>
                                        <Radio.Group defaultValue={"1"} value={userConfig?.uitranspose} onChange={val => setUserConfig("uitranspose", val, menuClose)}>
                                            <Space direction='vertical'>
                                                <Radio key={"1"} value="1" checked={userConfig?.uitranspose === "1"}> {t("Параметры в закладках")}</Radio>
                                                <Radio key={"2"} value="2" checked={userConfig?.uitranspose === "2"}> {t("Участники в закладках")}</Radio>
                                            </Space>
                                        </Radio.Group>
                                    </div>
                                    {(currentProtocol.Protocol.judgeBunch.bunch.tour.protocolValueTypeID !== 1) && <div style={{ paddingBottom: "10px" }}>
                                        <div style={{ paddingBottom: "5px", fontWeight: "300", color: "#747474" }}>{t('Способ ввода оценок')}</div>
                                        <Radio.Group defaultValue={"2"} value={userConfig?.ui} onChange={val => setUserConfig("ui", val, menuClose)}>
                                            <Space direction='vertical'>
                                                <Radio key={"1"} value="1" checked={userConfig?.ui === "1"}> {t("Одна кнопка")}</Radio>
                                                <Radio key={"2"} value="2" checked={userConfig?.ui === "2"}> {t("Группа кнопок")}</Radio>
                                                <Radio key={"3"} value="3" checked={userConfig?.ui === "3"}> {t("Всплывающий диалог")}</Radio>
                                                <Radio key={"4"} value="4" checked={userConfig?.ui === "4"}> {t("Диалог")}</Radio>
                                            </Space>
                                        </Radio.Group>
                                    </div>}
                                </div>

                            </Popup>
                            {statistic && <NavBar
                                mode="light"
                                right={
                                    <div key={"1"} onClick={onOpenChange} >
                                        <Icofont icon="gear" />
                                    </div>
                                }
                                backArrow={backArrow}
                                onBack={onBack}
                            >
                                <Picker popupClassName='presenter-picker'
                                    // getContainer={()=> document.body }
                                    style={{
                                        '--item-font-size': '13px'
                                    }}
                                    columns={[arrayProtocol.map(p => {
                                        return {
                                            ...p,
                                            label: <span>{(p.Protocol.genderID === 1) ? <MaleIcon fontSize="12px" /> : <FemaleIcon fontSize="12px" />} {"№ " + p.Protocol.judgeBunch.bunch.tour.number + "-" + p.Protocol.number + ", " +
                                                t(p.Protocol.judgeBunch.bunch.tour.kategoriiUchastnikovNaMeropriyatiyakh.kategoriyaUchastnikov.nazvanie)}
                                                <br />
                                                {t(p.Protocol.judgeBunch.bunch.tour.kategoriiUchastnikovNaMeropriyatiyakh.tantsevalnayaDistsiplina.nazvanie) + ", " +
                                                    t("Тур") + " " +
                                                    p.Protocol.judgeBunch.bunch.tour.number + ", " +
                                                    t("Заход") + " " + p.Protocol.judgeBunch.bunch.number}</span>,
                                            value: p.Protocol.ID
                                        }
                                    })]}
                                    value={[currentProtocol.Protocol.ID]}
                                    confirmText={t("Выбрать")}
                                    cancelText={t("Отмена")}
                                    title={t("Протокол")}
                                    onConfirm={e => {
                                        if (e.length) {
                                            setCurrentProtocol(dispatch, arrayProtocol, arrayProtocol.find(item => item.Protocol.ID === e[0]))
                                        }
                                    }}>
                                    {(items, { open }) => {
                                        return (
                                            <List.Item onClick={open} className={classes.pickerItem} arrow={false}>
                                                <span style={{ paddingRight: "4px" }}>{badge(statistic)}</span>{t("Протокол")} № {currentProtocol.Protocol.judgeBunch.bunch.tour.number}-{currentProtocol.Protocol.number}
                                            </List.Item>
                                        )
                                    }}

                                </Picker>
                            </NavBar>}
                            <Row gutter={[5, 5]}>
                                <Col span={24} style={{ fontSize: "12px", textAlign: "center" }}>
                                    <Collapse defaultActiveKey={["1"]}>
                                        <Collapse.Panel key='1' arrow={false} style={{ fontSize: "12px" }} title={
                                            <div>
                                                <Typography>{t("Судья")}: {currentProtocol.Protocol.judgeBunch.user.lastname + " " + currentProtocol.Protocol.judgeBunch.user.firstname}</Typography>
                                                <Typography><Ellipsis direction='end' rows={1} content={t(currentProtocol.Protocol.judgeBunch.bunch.tour.kategoriiUchastnikovNaMeropriyatiyakh.meropriyatie.nazvanieMeropriyatiya)} /></Typography>
                                                <Typography>{t(currentProtocol.Protocol.judgeBunch.bunch.tour.kategoriiUchastnikovNaMeropriyatiyakh.kategoriyaUchastnikov.nazvanie) + ", " + t(currentProtocol.Protocol.judgeBunch.bunch.tour.kategoriiUchastnikovNaMeropriyatiyakh.tantsevalnayaDistsiplina.nazvanie)}</Typography>
                                                <Typography>{t("Тур")} {currentProtocol.Protocol.judgeBunch.bunch.tour.number + " (" +
                                                    t(currentProtocol.Protocol.judgeBunch.bunch.tour.tourType.name) + "), " + t("Заход")} {currentProtocol.Protocol.judgeBunch.bunch.number}</Typography>
                                            </div>
                                        }>
                                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                <div>
                                                    {(currentProtocol.Protocol.genderID === 1) ? <MaleIcon title={t("Мужской")} fontSize="12px" /> : <FemaleIcon title={t("Женский")} fontSize="12px" />}
                                                </div>
                                                <div>
                                                    {JSX(() => {
                                                        if (currentProtocol.Protocol.judgeBunch.bunch.tour.protocolValueTypeID === 1) {
                                                            return ((currentProtocol.Protocol.genderID === 1) ? <span>
                                                                {t("Количество плюсов")}: {currentProtocol.Protocol.judgeBunch.bunch.tour.kolichestvoPlyusovPartneri}
                                                            </span> : <span>
                                                                {t("Количество плюсов")}: {currentProtocol.Protocol.judgeBunch.bunch.tour.kolichestvoPlyusovPartnershi}
                                                            </span>);
                                                        } else {
                                                            return ((currentProtocol.Protocol.genderID === 1) ? <span>
                                                                {t("Разрешено одинаковых оценок")}: {currentProtocol.Protocol.judgeBunch.bunch.tour.maksKolOdinakovikhOtsenokPartneri}
                                                            </span> : <span>
                                                                {t("Разрешено одинаковых оценок")}: {currentProtocol.Protocol.judgeBunch.bunch.tour.maksKolOdinakovikhOtsenokPartnershi}
                                                            </span>);
                                                        }
                                                    })}
                                                </div>
                                            </div>
                                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                <div>

                                                </div>
                                                <div>
                                                    {JSX(() => {
                                                        if (currentProtocol.Protocol.judgeBunch.bunch.tour.protocolValueTypeID === 2) {
                                                            if (currentProtocol.Protocol.genderID === 1 && currentProtocol.Protocol.judgeBunch.bunch.tour.kolOtsenokPoParametruPartneri) {
                                                                return <span>
                                                                    {t("Кол-во оценок по параметру")}: {currentProtocol.Protocol.judgeBunch.bunch.tour.kolOtsenokPoParametruPartneri}
                                                                </span>
                                                            } else if (currentProtocol.Protocol.genderID === 2 && currentProtocol.Protocol.judgeBunch.bunch.tour.kolOtsenokPoParametruPartnershi) {
                                                                return <span>
                                                                    {t("Кол-во оценок по параметру")}: {currentProtocol.Protocol.judgeBunch.bunch.tour.kolOtsenokPoParametruPartnershi}
                                                                </span>;
                                                            }
                                                            return <React.Fragment></React.Fragment>
                                                        }
                                                    })}
                                                </div>
                                            </div>
                                        </Collapse.Panel>
                                    </Collapse>
                                </Col>
                            </Row>
                        </div>
                        {statistic && <div style={{ paddingTop: "5px" }}>
                            <Button onClick={completed} disabled={!statistic.good || currentProtocol.Protocol.completed}
                                className={(statistic.good && !currentProtocol.Protocol.completed) ? "bg-green border-green" : "bg-grey border-grey"}
                                style={{ minHeight: "50px", width: "100%", borderRadius: "8px" }}>
                                {!currentProtocol.Protocol.completed ? t("Готово?") : t("Протокол заполнен")}
                            </Button>
                        </div>}
                        {(!userConfig || !userConfig?.uitranspose || userConfig?.uitranspose === "1") && <div style={{ display: "flex", alignItems: "center" }}>
                            <Tabs
                                key={currentProtocol?.Protocol?.ID}
                                className='protocol-tabs'
                                activeLineMode='fixed'
                                style={{
                                    flex: 1,
                                    '--title-font-size': '13px',
                                    '--content-padding': '5px'
                                }}
                            >
                                {JSXMap(parametersLine(), (tab, idx) => {
                                    return (
                                        <Tabs.Tab title={tab.title} key={idx}>
                                            {contentByParameter(tab)}
                                        </Tabs.Tab>
                                    )
                                })}
                            </Tabs>
                        </div>}
                        {(userConfig && userConfig?.uitranspose === "2") && <div style={{ display: "flex", alignItems: "center" }}>
                            <Tabs
                                key={currentProtocol?.Protocol?.ID}
                                className='protocol-tabs'
                                activeLineMode='fixed'
                                style={{
                                    flex: 1,
                                    '--title-font-size': '13px',
                                    '--content-padding': '5px'
                                }}
                            >
                                {JSXMap(peopleLine(), (tab, idx) => {
                                    return (
                                        <Tabs.Tab title={tab.title} key={idx}>
                                            {contentByPeouple(tab)}
                                        </Tabs.Tab>
                                    )
                                })}
                            </Tabs>
                        </div>}
                    </div>
                }
                {!currentProtocol && <>
                    <Row gutter={[5, 5]}>
                        <Col span={24} style={{ fontSize: "12px", textAlign: "center" }}>
                            <Typography style={{ fontSize: "14px", textAlign: "center", paddingBottom: "15px" }}>{t("Нет доступных протоколов")}</Typography>
                            <Button onClick={() => mycurrentprotocol(testing, event.ID, auth, dispatch, (currentProtocol) ? currentProtocol.Protocol : undefined)}>{t("Обновить")}</Button>
                        </Col>
                        {(event?.rezultatiOpublikovani) && <Col span={24} style={{ paddingTop: "25px" }}>
                            <a style={{ fontSize: "14px" }} href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app/reports/effektivnost-sudei/event/${event?.ID || ""}/`}>
                                {t("Эффективность судей")} <i className="fa fa-angle-right"></i>
                            </a>
                        </Col>}
                        {(event?.tekushchiiStatusMeropriyatiyaID == 5) && <Col span={24} style={{ paddingTop: "25px" }}>
                            <a style={{ fontSize: "14px" }} href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app/reports/otchetsudeiskogokomiteta/event/${event?.ID || ""}/`}>
                                {t("Судейский комитет")} <i className="fa fa-angle-right"></i>
                            </a>
                        </Col>}
                    </Row>
                </>}
                {loading && <div>
                    <MaskWithLoading loading={loading} />
                </div>}
            </div>
        </div>
    );
};
//--------------------------------------------------------------------------
